import {
    FormControl,
    FormHelperText,
    InputLabel,
    OutlinedInput,
    OutlinedInputProps
} from '@mui/material';
import { FieldState } from 'formstate';
import { observer } from 'mobx-react';
import * as React from 'react';

type DefaultTextFieldProps = {
    field: FieldState<string>;
    onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    helperText?: React.ReactNode;
    dataRole?: string;
} & OutlinedInputProps;

const DefaultTextField = (props: DefaultTextFieldProps) => {
    const {
        onChange,
        field,
        type,
        required,
        label,
        helperText,
        dataRole,
        inputProps,
        ...rest
    } = props;
    const { value, error } = field;
    return (
        <FormControl variant="outlined" error={!!error} fullWidth>
            <InputLabel required={required}>{label}</InputLabel>
            <OutlinedInput
                type={type && type}
                onBlur={() => field.validate()}
                onChange={e => {
                    if (onChange) {
                        onChange(e);
                    } else {
                        field.onChange(e.currentTarget.value);
                    }
                }}
                label={`${label}${required ? '*' : ''}`}
                value={value}
                inputProps={{
                    ...(dataRole && { 'data-role': dataRole }),
                    ...inputProps
                }}
                {...rest}
            />
            <FormHelperText>{error || helperText || ' '}</FormHelperText>
        </FormControl>
    );
};

export default observer(DefaultTextField);
